import JobTypes from "../Jobs/JobTypes";

let MoldeJobParts = [
  {
    label: "Configuracion de Partes",
    type: "Divider",
    id: "partSettings_div",
    size: 12,
    align: "center",
    orientation: "horizontal",
  },
  {
    inputName: "Type",
    label: "Tipo de parte",
    size: 6,
    type: "Text",
    id: "id_401",
  },
  {
    inputName: "jdfType",
    label: "Definicion JDF",
    size: 6,
    type: "Select",
    id: "id_4011",
    options: [
      { text: "Cover", value: "Cover" },
      { text: "Separated Parts Cover", value: "SeparatedCover" },
      { text: "Insert", value: "Insert" },
      { text: "Body", value: "Body" },
    ],
  },
  {
    inputName: "minWidth",
    label: "Ancho Minimo",
    type: "SmartMeasure",
    subtype: "length",
    size: { sm: 12, md: 3 },
    step: 1,
    id: "id_402",
  },
  {
    inputName: "maxWidth",
    label: "Ancho Maximo",
    type: "SmartMeasure",
    subtype: "length",
    size: { sm: 12, md: 3 },
    step: 1,
    id: "id_403",
  },
  {
    inputName: "minHeight",
    label: "Alto Minimo",
    type: "SmartMeasure",
    subtype: "length",
    size: { sm: 12, md: 3 },
    step: 1,
    id: "id_404",
  },
  {
    inputName: "maxHeight",
    label: "Alto Maximo",
    type: "SmartMeasure",
    subtype: "length",
    size: { sm: 12, md: 3 },
    step: 1,
    id: "id_405",
  },
  {
    inputName: "minPages",
    label: "Cantidad minima de paginas",
    type: "SmartMeasure",
    size: { sm: 12, md: 3 },
    step: 1,
    id: "id_406",
  },
  {
    inputName: "maxPages",
    label: "Cantidad máxima de paginas",
    type: "SmartMeasure",
    size: { sm: 12, md: 3 },
    step: 1,
    id: "id_407",
  },
  {
    inputName: "minStockWeight",
    label: "Gramaje minimo",
    type: "SmartMeasure",
    subtype: "weight",
    size: { sm: 12, md: 3 },
    id: "id_409",
  },
  {
    inputName: "maxStockWeight",
    label: "Gramaje maximo",
    type: "SmartMeasure",
    subtype: "weight",
    size: { sm: 12, md: 3 },
    id: "id_410",
  },
  {
    inputName: "PrintModAllowed",
    label: "Modo de impresion permitido",
    type: "Select",
    size: { sm: 12, md: 6 },
    id: "id_408",
    options: [
      { text: "Simplex", value: "Simplex" },
      { text: "Duplex", value: "Duplex" },
    ],
  },
  {
    type: "Divider",
    id: "jobAllowed_div",
    size: 12,
    align: "center",
    orientation: "horizontal",
  },
  {
    inputName: "jobTypesAllowed",
    label: "Tipos de trabajos asociados",
    type: "checkbox",
    id: "id_411",
    options: JobTypes.map((jt) => jt.name),
  },
];

export default MoldeJobParts;
